import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { format } from "date-fns";
import Pagination from "react-paginate";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import CouponModal from "../../../components/modal/CouponModal";

const TableList = (props) => {
  const [coupon, setCoupon] = useState(null);
  const [show, setShow] = useState(false);
  const [values, setValues] = useState("");

  useEffect(() => {
    setValues(props.List);
  }, [props.List]);

  const handlePageChange = (pageNumber) => {
    props.pageChange(pageNumber.selected + 1);
  };

  return (
    <div className="table-responsive">
      <Table hover className="overflow-auto borderless">
        <thead style={{ borderBottom: "#F5F5F9" }}>
          <tr className="table-head">
            <td className="">Coupon number</td>
            <td className="">Coupon Code</td>
            <td className="">Created On</td>
            <td className="">Expires On</td>
            <td className="">Status</td>
          </tr>
        </thead>
        <tbody>
          {values !== "" &&
            values.map((coupon) => {
              return (
                <tr
                  key={coupon.id}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setCoupon(coupon);
                    setShow(!show);
                  }}
                >
                  <td className="">{coupon.id}</td>
                  <td className="">{coupon.code}</td>
                  <td className="">
                    {format(new Date(coupon.start_date), "MMM dd, yyyy p")}
                  </td>
                  <td className="">
                    {format(new Date(coupon.expiry), "MMM dd,yyy p")}
                  </td>
                  <td className="">
                    <div className="status-text">
                      {new Date() > new Date(coupon.expiry)
                        ? "Expire"
                        : new Date() < new Date(coupon.start_date)
                        ? "Incoming"
                        : "Active"}
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
      {show && coupon && (
        <div className="modal-container">
          <CouponModal
            heading="Edit Coupon"
            cancleClick={() => setShow(false)}
            createClick={() => setShow(false)}
            editPage
            formData={coupon}
          />
        </div>
      )}
      {props.pagination?.total_pages && values.length > 0 && (
        <div
          className="d-flex justify-content-center mb-4 w-100"
          style={{ direction: "ltr" }}
        >
          <Pagination
            direction="ltr"
            previousLabel={<FaChevronLeft color="#404553" />}
            nextLabel={<FaChevronRight color="#404553" />}
            pageCount={props.pagination?.total_pages}
            onPageChange={handlePageChange}
            pageRangeDisplayed={2}
            containerClassName="pagination"
            forcePage={parseInt(props?.pagination?.page) - 1}
            pageClassName="ms-3 me-3 ps-3 pe-3 pt-2 pb-2"
            activeClassName={
              "ms-3 me-3 ps-1 pe-1 text-primary border border-primary font-weight-bold rounded bg-white"
            }
            nextClassName="bg-white ps-3 pe-3 pt-2 pb-2"
            previousClassName="bg-white ps-3 pe-3 pt-2 pb-2"
          />
        </div>
      )}
    </div>
  );
};

export default TableList;
